module.exports = __webpack_public_path__ + "static/logo-stellar-9bd76555ea5448ebaabff1107c4b502a.png";